<script lang="ts">
    import ListAndWordCard from '$lib/components/browse/ListAndWordCard.svelte';
    import AwaitSetup from '$lib/components/_page/await-setup.svelte';
    import type {LayoutData} from './$types'
    import {setContext} from 'svelte';
    import {keyBrowseNavigator} from '$lib/context-keys';

    export let data: LayoutData
    const {
        setup,
        currentWord,
        wordIdToSentences,
        loggedIn,
        device,
        userWordsMap,
        filterSettings,
        displayWords,
        browseNavigator,
    } = data

    setContext(keyBrowseNavigator, browseNavigator)

</script>

<svelte:head>
    {#if $currentWord}
        {#if $currentWord.id === 'art/der'}
            <title>Browse German Vocabulary | Filter by Level & Word Class | vocabeo Dictionary</title>
            <meta name="description"
                  content="Explore vocabeo's extensive word list featuring the most common words, sorted by frequency. Learn German in context with example sentences, images and audio.">
        {:else}
            <title>vocabeo - {$currentWord.word}</title>
            <meta name="description"
                  content="Look up the German-English translation of {$currentWord?.word} in vocabeo! Find example sentences with images and audio.">
            <!--NOTE will remove the "word" entries below the main google search result for 'vocabeo'..?-->
            <meta name="googlebot" content="nosnippet">
        {/if}
    {/if}
</svelte:head>

<AwaitSetup setup={setup}>
    <ListAndWordCard
            wordIdToSentences={wordIdToSentences}
            userWordsMap={userWordsMap}
            currentWord={currentWord}
            displayWords={displayWords}
            filterSettings={filterSettings}
            loggedIn={loggedIn}
            device={device}
    />
    <slot/>
</AwaitSetup>
